import React from 'react';
import { Link } from 'react-router-dom';

function formatAudienceCopy(audience, count) {
  if (audience === 'admin') {
    return {
      title: `Active promotion${count > 1 ? 's are' : ' is'} running now`,
      description: 'Keep this in mind while uploading shipments. Matching items will be discounted automatically for customers.',
      primaryLabel: 'Manage promotions',
      primaryTo: '/admin/promotions',
      secondaryLabel: 'Upload sheet',
      secondaryTo: '/admin/upload',
    };
  }

  if (audience === 'upload') {
    return {
      title: `Promotion${count > 1 ? 's' : ''} can apply to this upload`,
      description: 'Any matching items in this batch will pick up the active discount automatically during processing.',
      primaryLabel: 'Review promotions',
      primaryTo: '/admin/promotions',
      secondaryLabel: null,
      secondaryTo: null,
    };
  }

  return {
    title: `Save more on your next shipment`,
    description: 'Active promotions are already live in the system. Matching new shipments will be discounted automatically.',
    primaryLabel: 'Pay now',
    primaryTo: '/pay',
    secondaryLabel: 'View items',
    secondaryTo: '/items',
  };
}

function formatApplicability(promo) {
  let route;
  if (promo.applicable_to === 'cn_gh') route = 'China to Ghana';
  else if (promo.applicable_to === 'tr_gh') route = 'Turkey to Ghana';
  else if (promo.applicable_to === 'specific_goods') {
    route = promo.goods_filter ? `Selected goods: ${promo.goods_filter}` : 'Selected goods';
  } else {
    route = 'All routes';
  }

  if (promo.transport_mode === 'sea') return `${route} · Sea freight`;
  if (promo.transport_mode === 'air') return `${route} · Air freight`;
  return route;
}

export default function ActivePromotionsBanner({ promotions = [], audience = 'customer', className = '' }) {
  if (!promotions.length) return null;

  const copy = formatAudienceCopy(audience, promotions.length);
  const topPromotions = promotions.slice(0, 3);

  return (
    <div className={`promo-banner promo-banner--${audience} ${className}`.trim()}>
      <div className="promo-banner-header">
        <div>
          <p className="promo-banner-kicker">Active Promotions</p>
          <h3 className="promo-banner-title">{copy.title}</h3>
          <p className="promo-banner-copy">{copy.description}</p>
        </div>
        <div className="promo-banner-actions">
          {copy.primaryLabel ? (
            <Link to={copy.primaryTo} className="btn btn-primary btn-sm">
              {copy.primaryLabel}
            </Link>
          ) : null}
          {copy.secondaryLabel ? (
            <Link to={copy.secondaryTo} className="btn btn-outline btn-sm">
              {copy.secondaryLabel}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="promo-banner-list">
        {topPromotions.map((promo) => (
          <div key={promo.id} className="promo-banner-item">
            <div className="promo-banner-discount">{promo.discount_percent}% OFF</div>
            <div className="promo-banner-body">
              <p className="promo-banner-name">{promo.title}</p>
              <p className="promo-banner-meta">{formatApplicability(promo)}</p>
              <p className="promo-banner-text">{promo.description}</p>
            </div>
          </div>
        ))}
      </div>

      {promotions.length > topPromotions.length ? (
        <p className="promo-banner-more">
          +{promotions.length - topPromotions.length} more active promotion{promotions.length - topPromotions.length > 1 ? 's' : ''}
        </p>
      ) : null}
    </div>
  );
}
